import classnames from "classnames";
import React from "react";
import { FlexLayout } from "../layout/flex-layout";
import { SpacingBox } from "../layout/spacing-box";
import safetypayIconAsset from "../../assets/icons/ic-safetypay.png";
import "./footer.scss";
import { Typography } from "../typography/typography";
import { useWindowResolution } from "../../hooks/use-window-resolution";
import { useChannel } from "../../libs/channels/hooks/use-channel";

const Footer: React.FC = () => {
    const { isMobile } = useWindowResolution();
    const { isBcpTheme } = useChannel();
    return (
        <FlexLayout
            className={classnames("footer", {
                "footer--bcp": isBcpTheme,
            })}
            justify="center"
            align="center"
            direction="column"
            data-testid="footer"
        >
            <div className="footer__separator" />
            <SpacingBox className="footer__container">
                <SpacingBox
                    className="footer__payment-methods"
                    mt={!isBcpTheme ? 8 : 0}
                    mb={!isBcpTheme ? 8 : 0}
                >
                    <img src={safetypayIconAsset} width={isMobile ? 83 : 134} />
                </SpacingBox>
                {isMobile && <div className="footer__separator" />}
                <FlexLayout
                    justify="center"
                    align={isMobile ? "center" : "flex-start"}
                    direction="column"
                    className="footer__information"
                    mt={8}
                    mb={8}
                >
                    <Typography
                        fontSize={isMobile ? 12 : 14}
                        variant={isBcpTheme ? "white" : "gray-light-2"}
                        data-testid="footer-call"
                    >
                        {!isBcpTheme ? (
                            <>
                                <b>¿Dudas? Llámanos al </b>
                                <Typography
                                    fontSize={isMobile ? 14 : 16}
                                    variant={"gray-light-2"}
                                >
                                    <b>(01) 513-5000 </b>
                                </Typography>
                            </>
                        ) : (
                            <>
                                <b>Si tienes dudas contáctanos al </b>
                                <Typography
                                    fontSize={isMobile ? 14 : 16}
                                    variant="white"
                                >
                                    <b>(01) 311-0800</b>
                                </Typography>
                            </>
                        )}
                    </Typography>
                    <Typography
                        variant={isBcpTheme ? "white" : "gray-light-2"}
                        fontSize={isMobile ? 10 : 14}
                        data-testid="footer-address"
                    >
                        {isBcpTheme
                            ? "Sede Central, Cal. Centenario 156, La Molina 15026, Lima - Perú"
                            : "Av. Juan de Arona 830, San Isidro - Lima 27"}
                    </Typography>
                </FlexLayout>
            </SpacingBox>
            <div className="footer__separator" />
            <SpacingBox className="footer__extra-information" mt={19} mb={9}>
                <Typography
                    fontSize={isMobile ? 10 : 14}
                    variant={isBcpTheme ? "white" : "gray-light-2"}
                >
                    Esta página web está protegida por reCAPTCHA y se aplican
                    las&nbsp;
                    <br className="hide-mobile" />
                    <a
                        href="https://policies.google.com/privacy"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Políticas de privacidad
                    </a>{" "}
                    y los{" "}
                    <a
                        href="https://policies.google.com/terms"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Términos de servicio
                    </a>{" "}
                    de Google.
                </Typography>
            </SpacingBox>
        </FlexLayout>
    );
};

export default Footer;
